/**
 * Race Filters Toggle
 * Handles show/hide functionality for race filters
 */

class RaceFiltersToggle {
	constructor() {
		this.filterContainer = document.querySelector('.race-filters');
		this.toggleButton = document.querySelector('.filters-toggle');

		if (!this.filterContainer || !this.toggleButton) {
			return;
		}

		this.init();
	}

	init() {
		// Check if filters should be collapsed by default (no active filters)
		const hasActiveFilters = this.checkActiveFilters();

		if (!hasActiveFilters) {
			this.filterContainer.classList.add('collapsed');
		}

		// Add click event listener
		this.toggleButton.addEventListener('click', () => {
			this.toggleFilters();
		});
	}

	checkActiveFilters() {
		const urlParams = new URLSearchParams(window.location.search);
		return urlParams.has('search_query') ||
		       urlParams.has('start_date') ||
		       urlParams.has('end_date') ||
		       urlParams.has('discipline');
	}

	toggleFilters() {
		this.filterContainer.classList.toggle('collapsed');
	}
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => {
		new RaceFiltersToggle();
	});
} else {
	new RaceFiltersToggle();
}

export default RaceFiltersToggle;
